export default "__VITE_ASSET__DrYCZ$5Y__"